import { useSubscription } from './chunk-J4IY6DLG.mjs';
import { useAuthContext } from './chunk-K3UDKV2P.mjs';
import { graphql } from './chunk-NWN55YVG.mjs';

// src/universal/hooks/useNotificationsSubscription/index.ts
var NOTIFICATIONS_SUBSCRIPTION = graphql(
  /* GraphQL */
  `
  subscription Notifications {
    notifications(order_by: { createdAt: desc }) {
      id
      entityId
      entityType
      type
      readAt
      link
      metadata
      video {
        id
        title
      }
    }
  }
`
);
function useNotificationsSubscription(url) {
  var _a;
  const { isSignedIn } = useAuthContext();
  const subscription = useSubscription({
    hasuraUrl: url,
    query: NOTIFICATIONS_SUBSCRIPTION.toString(),
    enabled: isSignedIn
  });
  return {
    data: subscription.isLoading ? null : ((_a = subscription.data) == null ? void 0 : _a.notifications) || [],
    isLoading: subscription.isLoading,
    error: subscription.error
  };
}

export { useNotificationsSubscription };
//# sourceMappingURL=chunk-VGNWDLIO.mjs.map
//# sourceMappingURL=chunk-VGNWDLIO.mjs.map